var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScenarios({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.713 40.258h34.574V7.742H6.713v32.516zm-1.985 1.984h38.543V5.758H4.728v36.484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.788 36.168h26.424v-1.984H10.788zM25.945 30.58h11.267v-1.984H25.945zM25.945 24.992h11.267v-1.984H25.945zM25.945 19.404h11.267V17.42H25.945zM10.788 13.816h26.424v-1.984H10.788zM10.788 19.404h11.267V17.42H10.788zM10.788 30.58h11.267v-1.984H10.788zM10.788 24.992h11.267v-1.984H10.788z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarios);
export default __webpack_public_path__ + "static/media/scenarios.dd15becab5b7267a12aef827fcfef561.svg";
export { ForwardRef as ReactComponent };